export default __webpack_public_path__ + "static/media/mars5.c684979f.gif";